export const BED_IPD_DASHBOARD_URL = '/bedIpd/ipVisit/dashboard'
export const IP_VISIT_VITALS_URL = '/visits/ipdVisit/'
export const USER_CREATATION = '/administration/userCreation'
export const Edit = 'edit'
export const Create = 'create'
export const doctor = '/administration/doctors'
export const partners = '/administration/referredOut'
export const radilogist = '/administration/radiologist'
export const proRithmDashboard = '/deviceMappings'
export const pathologist = 'administration/pathologist'
export const labDevices = '/labDevices'
export const radiologyDevices = '/radiologyDevices'
export const editABMembership = '/ab/membership-edit'
export const ABMemberDashboard = '/ab/membership-dashboard/'
export const ABMemebrship = '/ab/membership'
export const labordercreate = '/lms/search/createorder'
export const laborercollect = '/lms/search/collect/'
export const KEYCLOCK_ROLES = 'keyclock/roles'
export const registration = '/patient-registration'
export const searchpatient = 'api/fhir/Patient?identifier='
export const userCreation = '/userdata'
export const keycloakRoleRemoval = 'api/ipd/keycloak/removeRole?id='
export const BackLogOrders = 'api/api/rest/backlogordersonview-backlogdata'
export const CurrentOrders = 'api/api/rest/backlogordersonview-currentdata'
export const getWardsAndBeds = 'api/api/rest/wards/beds'
export const getBedsByLocation = 'api/api/rest/beds/location'
export const getAllLabDepartmentsEndpoint = 'api/api/rest/departments'
export const labDeviceModel = '/labDeviceModel'
export const AllCompanies = 'api/api/rest/get-company'
export const UpdateLablocation = 'api/laborders/v1/update'
export const orderinvoice = '/orderinvoice'
export const labDashboard = '/lms'
export const parameterMappings = '/labDeviceModel/Parameters'
export const visits = '/visits'
export const routePackage = '/package'
export const updateLabOrderPhases = 'api/api/rest/update-lab-orders-phases'
export const updateOrderEvent = 'api/api/rest/update-order-event'
export const getLabOrders = 'api/api/rest/get-lab-orders-new'
export const BulkBedCreation = 'api/api/rest/bulk-bed-config'
export const bulktestconfig = 'api/api/rest/bulk-panel-config'
export const bulkparameterconfig = 'api/api/rest/bulk-parameter-config'
export const bulkparameterrangeconfig =
  'api/api/rest/bulk-parameterrange-config'
export const bulkpackageconfig = 'api/api/rest/bulk-packages-config'
export const fetchBeds = 'api/api/rest/fetch-beds'
export const GET_ALL_BEDS_PATIENTS_ENDPOINT = 'api/api/rest/beds-patients'
export const GET_ASSIGNED_PATIENTS_FOR_A_BED_ENDPOINT =
  'api/api/rest/bed-assignment?bedStatus='
export const SEND_WHATSAPP_MESSAGE = '/api/whatsapp/send'
export const archiveBedApi = 'api/api/rest/bed-assignment/'
export const deleteBedApi = 'api/api/rest/bed-assignment/'
export const getBedAssignmentByPatientIdEndpoint =
  'api/api/rest/bed-assignment-patientId'
export const RADIOLOGY_FILE_UPLOAD_ENDPOINT = 'api/ipd/radiologyFile/upload'
export const RADIOLOGY_GET_DOCUMENTS_ENDPOINT =
  'api/ipd/radiologyFile/getdocumentIds'
export const GET_BEDS_BY_ROOM = '/api/rest/get-beds-by-room'
export const GET_WARD_BY_LOC = '/api/rest/wardsByLocation'
export const GET_ROOMS_BY_WARD = '/api/rest/get-rooms-by-ward'
export const RADIOLOGY_ORDERS_OPD_LOCATION =
  'api/api/rest/radiology-orders/opd/location'
